/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const getApiEmployeesIdCvPreviewPathParamsSchema = z.object({
  id: z.coerce.number().int(),
});

/**
 * @description OK
 */
export const getApiEmployeesIdCvPreview200Schema = z.any();

export const getApiEmployeesIdCvPreviewQueryResponseSchema = z.lazy(
  () => getApiEmployeesIdCvPreview200Schema,
);
